import { FILTER_FIELD_TYPES } from '../../ui/data/filters/filterTypes';

export const TEST_CASE_FILTER_DEFAULTS = {
  status: 'All',
  priority: 'All',
  owner: [],
  module: [],
  technologyLayer: 'All',
  labels: [],
  isAutomationNeeded: 'All',
  isAutomated: 'All',
  testSuites: [],
  reviewer: [],
  platforms: [],
  subPlatforms: [],
  browsers: [],
  geographies: [],
  languages: [],
  cloudDevice: [],
};

export function buildTestCaseFilterConfig({ isReviewWorkflow = false, reviewableStatuses = [] } = {}) {
  return [
    {
      key: 'status',
      label: 'Status',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: 'All',
      gridSize: 4,
    },
    {
      key: 'priority',
      label: 'Priority',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: 'All',
      gridSize: 4,
    },
    {
      key: 'owner',
      label: 'Author',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      placeholder: 'Select authors',
    },
    {
      key: 'module',
      label: 'Project Module',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      placeholder: 'Select modules',
    },
    {
      key: 'technologyLayer',
      label: 'Technology Layer',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: 'All',
      gridSize: 4,
    },
    {
      key: 'labels',
      label: 'Labels',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      placeholder: 'Select labels',
    },
    {
      key: 'isAutomationNeeded',
      label: 'Candidate for Automation',
      type: FILTER_FIELD_TYPES.ENUM,
      defaultValue: 'All',
      gridSize: 4,
      enumOptions: [
        { value: 'All', label: 'All' },
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' },
      ],
    },
    {
      key: 'isAutomated',
      label: 'Is Automated?',
      type: FILTER_FIELD_TYPES.ENUM,
      defaultValue: 'All',
      gridSize: 4,
      enumOptions: [
        { value: 'All', label: 'All' },
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' },
      ],
    },
    {
      key: 'testSuites',
      label: 'Test Suites',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      placeholder: 'Select test suites',
    },
    {
      key: 'platforms',
      label: 'Platforms',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      placeholder: 'Select platforms',
      // hide from FilterModal filter fields — shown via ExecutionScopeForm
      hiddenField: true,
    },
    {
      key: 'subPlatforms',
      label: 'Sub Platforms',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      hiddenField: true,
    },
    {
      key: 'browsers',
      label: 'Browsers',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      hiddenField: true,
    },
    {
      key: 'geographies',
      label: 'Geographies',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      hiddenField: true,
    },
    {
      key: 'languages',
      label: 'Languages',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      hiddenField: true,
    },
    {
      key: 'cloudDevice',
      label: 'Cloud Device Labs',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 4,
      hiddenField: true,
    },
    ...(isReviewWorkflow
      ? [
        {
          key: 'reviewer',
          label: 'Reviewer / Approved By',
          type: FILTER_FIELD_TYPES.MULTI_SELECT,
          defaultValue: [],
          gridSize: 4,
          placeholder: 'Select reviewers',
          visibleWhen: (filters) => reviewableStatuses.includes(filters.status),
        },
      ]
      : []),
  ];
}